export const HEADER = "طلبات التحويل";
export const PENDING_CASHOUTS_TAB = "بانتظار التحويل";
export const FINISHED_CASHOUTS_TAB = "تم التحويل";
export const BUTTON = {
  SEARCH: "البحث عن طريق رمز المعاملة",
  SEARCH_TRANS: "البحث عن طريق رمز الدفع",
};
export const TABLE_HEADERS = {
  TRANSACTION_NAME: "المعاملة",
  TRANSACTION_ID: "رمز المعاملة",
  CASHOUTS_NUMBER: "عدد التحويلات",
  TOTAL_AMOUNT: "القيمة الإجمالية",
  STATUS: "الحالة",
};
